import React, { useContext, useEffect, useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FiAlertCircle, FiArrowRight, FiCheck } from "react-icons/fi";
import { CartContext } from "./CartContext";
import siteConfig from "../config/siteConfig";
import "../css/paymentstatus.css";

function PaymentStatus() {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const succeeded = searchParams.get("state") === "success";
  const order = useMemo(() => {
    try {
      const raw = window.sessionStorage.getItem(siteConfig.checkout.lastOrderStorageKey);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  useEffect(() => {
    if (succeeded) clearCart();
  }, [succeeded, clearCart]);

  return (
    <main className="success-page" id="main-content">
      <section className="success-card">
        <div className={`success-mark ${succeeded ? "" : "success-mark--cancel"}`}>{succeeded ? <FiCheck /> : <FiAlertCircle />}</div>
        <p className="eyebrow">{succeeded ? "PAYMENT SUCCESSFUL" : "PAYMENT NOT COMPLETED"}</p>
        <h1>{succeeded ? "Thank you. Your order is confirmed." : "Your order is still waiting for you."}</h1>
        <p>{succeeded ? "We have received your payment and will prepare your order with care. Delivery updates will be sent to the email used at checkout." : "No completed payment was recorded. Your items remain in the cart, so you can review the details and try again whenever you are ready."}</p>
        {order && <dl><div><dt>ORDER</dt><dd>{order.orderNumber}</dd></div><div><dt>TOTAL</dt><dd>{order.total}</dd></div><div><dt>EMAIL</dt><dd>{order.email}</dd></div></dl>}
        <div className="success-actions">
          <Link className="button button--dark" to={succeeded ? "/shop" : "/checkout"}>{succeeded ? "CONTINUE SHOPPING" : "RETURN TO CHECKOUT"} <FiArrowRight /></Link>
          <Link className="text-link" to="/contact">CONTACT CUSTOMER CARE</Link>
        </div>
      </section>
      <aside className="success-image"><img src="/img/generated/payment-status.png" alt="A carefully packed stationery order ready for delivery" /><p>{succeeded ? "YOUR ORDER IS NOW IN CAREFUL HANDS." : "YOUR CART HAS BEEN KEPT INTACT."}</p></aside>
    </main>
  );
}

export default PaymentStatus;
